var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadgeGlutenFree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 100.92 100.92",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-250.04 -252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m300.5 352.92a50.46 50.46 0 1 1 35.7-14.76 50.33 50.33 0 0 1 -35.7 14.76zm0-95.2a44.75 44.75 0 1 0 31.65 13.09 44.6 44.6 0 0 0 -31.65-13.09z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m302.25 330.7h-5.81a13.22 13.22 0 0 1 -13.21-13.21v-3.4a2.41 2.41 0 0 1 2.41-2.41h3.36a13.22 13.22 0 0 1 13.21 13.21zm-15-15v1.8a9.21 9.21 0 0 0 9.2 9.2h1.8v-1.8a9.21 9.21 0 0 0 -9.2-9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m302.25 316.71h-5.81a13.21 13.21 0 0 1 -13.21-13.21v-3.39a2.41 2.41 0 0 1 2.41-2.41h3.36a13.21 13.21 0 0 1 13.21 13.21zm-15-15v1.79a9.22 9.22 0 0 0 9.2 9.21h1.8v-1.8a9.21 9.21 0 0 0 -9.2-9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m302.25 302.73h-5.81a13.22 13.22 0 0 1 -13.21-13.21v-3.4a2.41 2.41 0 0 1 2.41-2.41h3.36a13.22 13.22 0 0 1 13.21 13.21zm-15-15v1.8a9.21 9.21 0 0 0 9.2 9.2h1.8v-1.8a9.21 9.21 0 0 0 -9.2-9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304 330.7h-5.81v-5.81a13.21 13.21 0 0 1 13.21-13.21h3.39a2.4 2.4 0 0 1 2.41 2.41v3.4a13.21 13.21 0 0 1 -13.2 13.21zm-1.8-4h1.8a9.21 9.21 0 0 0 9.2-9.2v-1.8h-1.8a9.21 9.21 0 0 0 -9.2 9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304 316.71h-5.81v-5.8a13.2 13.2 0 0 1 13.21-13.21h3.39a2.4 2.4 0 0 1 2.41 2.41v3.39a13.2 13.2 0 0 1 -13.2 13.21zm-1.8-4h1.8a9.22 9.22 0 0 0 9.2-9.21v-1.79h-1.8a9.21 9.21 0 0 0 -9.2 9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m304 302.73h-5.81v-5.81a13.21 13.21 0 0 1 13.21-13.21h3.76a2 2 0 0 1 2 2.05v3.76a13.21 13.21 0 0 1 -13.16 13.21zm-1.8-4h1.8a9.21 9.21 0 0 0 9.2-9.2v-1.8h-1.8a9.21 9.21 0 0 0 -9.2 9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300.23 294.24-4.23-4.24a13.83 13.83 0 0 1 0-19.57l2.88-2.88a1.94 1.94 0 0 1 2.75 0l2.88 2.88a13.85 13.85 0 0 1 0 19.57zm0-22.41-1.42 1.42a9.86 9.86 0 0 0 0 13.91l1.42 1.42 1.43-1.42a9.86 9.86 0 0 0 0-13.91z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m300.29 339.14a2 2 0 0 1 -2-2v-45.73a2 2 0 0 1 4 0v45.72a2 2 0 0 1 -2 2.01z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.28 320.19a13.43 13.43 0 0 1 -.74-3.7l-18.18 18.19a2.07 2.07 0 0 0 1.46 3.53 2.11 2.11 0 0 0 1.47-.61l16.37-16.37c-.13-.35-.26-.69-.38-1.04z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m335.64 267.32a2.07 2.07 0 0 0 -2.93 0l-17.32 17.33c1.13.94 1.37 2.77 1.47 4.12a2.09 2.09 0 0 0 0 .25l18.77-18.77a2.07 2.07 0 0 0 .01-2.93z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeGlutenFree);
export default __webpack_public_path__ + "static/media/badge_gluten_free.6a1d42413c776ec23cb66ae08c942f6f.svg";
export { ForwardRef as ReactComponent };